const midpoint = 2

const properties = {
  strokeWidth: 1,
  strokeColour: 'black',
  lineLipWidth: 10,
}

type PropTypes = {
  label?: string,
  startPoint: number,
  endPoint: number,
  yOffset?: number,
}

const HorizontalMeasurement = ({ label, startPoint, endPoint, yOffset = 0 }: PropTypes) => {
  return (
    <g>
      <text
        // Text should always display midway between the start and end points
        x={(startPoint + endPoint) / midpoint}
        y={yOffset - (properties.lineLipWidth / 2)}
        textAnchor="middle"
        className="text-xs"
      >
        { label }
      </text>

      <line
        x1={startPoint}
        // The line should be offset by half the lip width so it's centred
        y1={yOffset - (properties.lineLipWidth / midpoint)}
        x2={startPoint}
        // The line should be offset by half the lip width so it's centred
        y2={yOffset + (properties.lineLipWidth / midpoint)}
        stroke={properties.strokeColour}
        strokeWidth={properties.strokeWidth}
      />
      <line
        x1={startPoint}
        y1={yOffset}
        x2={endPoint}
        y2={yOffset}
        stroke={properties.strokeColour}
        strokeWidth={properties.strokeWidth}
      />
      <line
        x1={endPoint}
        // The line should be offset by half the lip width so it's centred
        y1={yOffset - (properties.lineLipWidth / midpoint)}
        x2={endPoint}
        // The line should be offset by half the lip width so it's centred
        y2={yOffset + (properties.lineLipWidth / midpoint)}
        stroke={properties.strokeColour}
        strokeWidth={properties.strokeWidth}
      />
    </g>
  )
}

export default HorizontalMeasurement
